import { PureComponent } from 'react';

import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import Breadcrumbs, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';
import CustomThemeButton from '@atlaskit/button/custom-theme-button';

import { FocusedPageHeader } from 'src/components/accessibility';
import { ComponentLink } from 'src/components/component-link';
import { User, Workspace } from 'src/components/types';
import { getProfileUrl } from 'src/components/user-profile';
import { commonMessages } from 'src/i18n';
import {
  getCurrentWorkspace,
  getIsProfileAdminStatus,
  getProfileUuid,
} from 'src/redux/profile/selectors';
import messages from 'src/sections/profile/sections/repositories/components/profile-repositories-header.i18n';
import { useWorkspaceNavActionUrls } from 'src/sections/workspace/components/navigation/use-container-navigation-props';
import WorkspaceIcon from 'src/sections/workspace/components/workspace-icon';
import { getTargetUser } from 'src/selectors/user-selectors';
import { BucketState } from 'src/types/state';

type Props = {
  targetUser: User | null | undefined;
  currentWorkspace: Workspace;
  profileUuid: string;
  isAdmin: boolean;
};

export function CreateRepoButton(): JSX.Element | null {
  const { createRepoUrl } = useWorkspaceNavActionUrls();

  return createRepoUrl ? (
    <CustomThemeButton testId="create-repository-button" href={createRepoUrl}>
      <FormattedMessage {...commonMessages.createRepositoryButton} />
    </CustomThemeButton>
  ) : null;
}

export class ProfileRepositoriesHeader extends PureComponent<Props> {
  // eslint-disable-next-line consistent-return
  getBreadcrumbs() {
    const { currentWorkspace, targetUser } = this.props;

    if (currentWorkspace) {
      const icon = <WorkspaceIcon workspace={currentWorkspace} />;

      return (
        <Breadcrumbs>
          <BreadcrumbsItem
            text={currentWorkspace.name}
            href={currentWorkspace.links.html.href}
            component={ComponentLink}
            iconBefore={icon}
          />
        </Breadcrumbs>
      );
    }

    if (targetUser) {
      return (
        <Breadcrumbs>
          <BreadcrumbsItem
            text={targetUser.display_name}
            href={getProfileUrl(targetUser)}
            component={ComponentLink}
          />
        </Breadcrumbs>
      );
    }
  }

  render() {
    return (
      <FocusedPageHeader
        actions={this.props.isAdmin ? <CreateRepoButton /> : undefined}
        breadcrumbs={this.getBreadcrumbs()}
      >
        <FormattedMessage {...messages.pageTitle} />
      </FocusedPageHeader>
    );
  }
}

const mapStateToProps = (state: BucketState) => {
  return {
    currentWorkspace: getCurrentWorkspace(state),
    targetUser: getTargetUser(state),
    profileUuid: getProfileUuid(state),
    isAdmin: getIsProfileAdminStatus(state),
  };
};

export default connect(mapStateToProps)(ProfileRepositoriesHeader);
